<script setup lang="ts">
import { cn } from '@/lib/utils'
import { inject } from 'vue'
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
  classIcon?: HTMLAttributes['class']
}>()

const { isOpen } = inject('select', {
  isOpen: { value: false }
})

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <button
    type="button"
    @click="toggleDropdown"
    :class="cn(
      'flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
      isOpen ? 'ring-2 ring-ring ring-offset-2' : '',
      props.class
    )"
  >
    <slot />
    <svg
      :class="[{ 'rotate-180': isOpen }, classIcon]"
      class="h-4 w-4 transition-transform duration-200"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  </button>
</template>
